import React, { useEffect, useState } from "react";
import tw from "tailwind-styled-components";
import { MdClose } from "react-icons/md";
import { capitalizeFirstLetter } from "../../../helpers";
import moment from "moment";

const ViewPropsModel = ({ handleClose, selectedData }) => {
    const [height, setHeight] = useState(window.innerHeight);

    useEffect(() => {
        const handleResize = () => setHeight(window.innerHeight);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <Container style={{ height }}>
            {/* Header */}
            <Header>
                <h1 className="text-white text-lg font-medium">
                    Properties Details
                </h1>
                <button onClick={handleClose}>
                    <MdClose color="white" size={24} />
                </button>
            </Header>

            {/* Primary Tenant Info */}
            <ProfileSection>
                <UserInfo>
                    <span className="text-lg font-semibold">
                        {capitalizeFirstLetter(selectedData?.clientName || "")}
                    </span>
                    <span className="text-sm text-gray-600">
                        {'#' + selectedData?.clientMobile}
                    </span>
                </UserInfo>

                <Summary>
                    <SummaryItem>
                        {/* <span className="font-medium text-gray-800">Properties</span>
                        <span className="text-sm text-gray-100">
                            {selectedData?.properties?.length || 0}
                        </span> */}
                        <span className="text-xs text-gray-500">Properties</span>
                        <span className="text-lg font-semibold">
                            {selectedData?.properties?.length || 0}
                        </span>
                    </SummaryItem>
                </Summary>
            </ProfileSection>

            {/* Property List */}
            <Content>
                {selectedData?.properties?.length > 0 ? (
                    selectedData.properties.map((property, index) => (
                        <PropertyCard key={property.id || index}>
                            <CardHeader>
                                <div>
                                    <p className="font-medium text-gray-800">{property.name}</p>
                                    <p className="font-normal text-sm text-gray-500">{property.address}</p>
                                </div>
                                <StatusBadge status={property.agreementStatus}>
                                    {property.agreementStatus || "N/A"}
                                </StatusBadge>
                            </CardHeader>

                            <Divider />

                            <Grid>
                                <FlexCol>
                                    <Label>Rent</Label>
                                    <Value>₹{property.leaseRent || 0}</Value>
                                </FlexCol>

                                <FlexCol>
                                    <Label>Security</Label>
                                    <Value>₹{property.leaseSecurity || 0}</Value>
                                </FlexCol>
                                <FlexCol>
                                    <Label>Agreement</Label>
                                    <Value>
                                        {property.startDate
                                            ?
                                            (property.startDate
                                                ? moment(property.startDate).format("DD, MMM YY")
                                                : "-")
                                            + ' - ' +
                                            (property.endDate
                                                ? moment(property.endDate).format("DD, MMM YY")
                                                : "-")
                                            : "Not Available"}
                                    </Value>
                                </FlexCol>
                                <FlexCol>
                                    <Label>Dues</Label>
                                    <Value className="text-red-600 font-medium">
                                        ₹{property.pendingDues || 0}
                                    </Value>
                                </FlexCol>
                            </Grid>
                        </PropertyCard>
                    ))
                ) : (
                    <EmptyState>No properties found</EmptyState>
                )}
            </Content>
        </Container>
    );
};

/* ---------------- styled components ---------------- */

const Container = tw.div`bg-white w-full h-full flex flex-col`;
const Header = tw.div`flex items-center justify-between bg-primary-color px-4 py-4`;
const ProfileSection = tw.div`
  bg-gray-100 px-4 py-3 flex justify-between items-center
`;
const UserInfo = tw.div`flex flex-col`;
const Summary = tw.div`flex gap-6`;
const SummaryItem = tw.div`
  flex flex-col text-right
  .label { @apply text-xs text-gray-500; }
  .value { @apply text-lg font-semibold; }
`;
const Content = tw.div`px-4 py-4 space-y-4 overflow-y-auto`;
const PropertyCard = tw.div`
  bg-white border border-gray-200 rounded-lg p-4
`;
const CardHeader = tw.div`
  flex justify-between items-start
  .name { @apply font-medium text-gray-800; }
  .address { @apply text-sm text-gray-500; }
`;
const StatusBadge = tw.span`
  text-xs px-2 py-1 rounded-full
  ${({ status }) =>
        status === "Active"
            ? "bg-green-100 text-green-700"
            : status === "Expiring"
                ? "bg-amber-100 text-amber-700"
                : "bg-gray-100 text-gray-600"}
`;
const Divider = tw.div`h-px bg-gray-200 my-3`;
const Grid = tw.div`grid grid-cols-2 gap-4`;
const Label = tw.label`text-sm text-gray-400 font-normal`;
const Value = tw.span`text-gray-600 text-sm md:text-base`;
const FlexCol = tw.div`flex flex-col gap-0.5`;
const EmptyState = tw.div`
  text-center text-gray-500 text-sm py-10
`;

export default ViewPropsModel;
